import * as colors from '../../styles/colors';

export const defaultTheme = {
  checkboxBorderColor: colors.blueGrey60,
  checkboxBackground: colors.backgroundWhite,
  checkboxCheckedBackground: colors.darkGreen,
  checkboxCheckedBorderColor: colors.darkGreen,
  checkboxIconColor: colors.backgroundWhite,
};
